import { Box, Grid, Stack, Typography } from '@mui/material'
import CardTitle from './cardTitle';
import ClickableCard from '../../common/clickableCard';
import SkeletonCard from '../../common/skeletonCard';
import custom from '../../../styles/mui/szVariables.json'

export default function GridUsageCard({ 
        id, color, content, handleCardClick }: any) {
    if(!content) return (
        <SkeletonCard height="144px" />
    )
    return (
        <ClickableCard
                id={id}
                height="144px"
                px={custom.spacing.sm}
                py={custom.spacing.sm}
                handleCardClick={ ()=>handleCardClick(true)}
            >
             <Grid container direction="column" 
                    justifyContent="flex-start" 
                    width="100%">
                <Grid item>
                    <CardTitle icon={content?.icon} 
                        cardTitle={content.cardTitle} 
                        hoverIcon={content.hoverIcon} 
                        id={id}/>
                </Grid>
                <Grid item mt={custom.spacing.xl}>
                    <Stack alignItems="start" direction="row" >
                        <Box>
                            <Typography variant='szHeading.Bold.Large' 
                                    id='imported' >
                                {content.imported}
                                <Typography pl={custom.spacing.xxxxs} 
                                    variant="szHeading.Regular.Small" >
                                    {content.unit}
                                </Typography>
                            </Typography>
                            <Typography component="p" 
                                sx={{ color: 'text.primary'}}
                                variant="szBody.Regular.Small" >
                                {content.descImported}
                            </Typography>
                        </Box>
                        <Box ml="auto">
                            <Typography variant='szHeading.Bold.Large'
                                id='exported'>
                                {content.exported}
                                <Typography pl={custom.spacing.xxxxs} 
                                    variant="szHeading.Regular.Small" >
                                    {content.unit}
                                </Typography>
                            </Typography>
                            <Typography component="p" 
                                sx={{ color: 'text.primary'}}
                                variant="szBody.Regular.Small" >
                                {content.descExported}
                            </Typography>
                        </Box>
                    </Stack>
                </Grid>
            </Grid>  
        </ClickableCard>
    )
}